import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "../src/css/common.css";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";

import { useEffect, useState, Suspense } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Loading from './Loading';

import { DarkModeProvider } from './components/context/DarkModeContext';
import { ChatEnableProvider } from './components/context/ChatEnablerContext';

import ScrollToTop from "./components/scroll-to-top/ScrollToTop";
import SystemLoader from "./components/Krishpar/MainLoader";

export default function App() {

  // Suppress ResizeObserver error in dev console
  const ignoreResizeObserverError = () => {
    const error = console.error;
    console.error = (...args) => {
      if (
        args[0]?.toString().includes('ResizeObserver loop completed') ||
        args[0]?.toString().includes('ResizeObserver loop limit exceeded')
      ) {
        return;
      }
      error(...args);
    };
  };

  ignoreResizeObserverError();

  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") || ""
  );
  const [userDesignation, setUserDesignation] = useState(
    localStorage.getItem("UserDesignation") || ""
  );

  useEffect(() => {
    if (!localStorage.getItem("isAuthenticated")) {
      localStorage.setItem("isAuthenticated", isAuthenticated);
    }
    if (!localStorage.getItem("UserDesignation")) {
      localStorage.setItem("UserDesignation", userDesignation);
    }
  }, [isAuthenticated, userDesignation]);

  const handleLogin = (data) => {
    setIsAuthenticated(data);
    setUserDesignation(localStorage.getItem("UserDesignation") || "");
    localStorage.setItem("isAuthenticated", data);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserDesignation("");
    const RESET_PASSWORD = localStorage.getItem("RESET_PASSWORD");
    localStorage.clear();
    localStorage.setItem("RESET_PASSWORD", RESET_PASSWORD)
  };

  return (
    <DarkModeProvider>
      <HelmetProvider>
        <BrowserRouter>
          <Suspense fallback={<SystemLoader text="Loading..." />}>
            <ThemeProvider>
              <ScrollToTop />
              <ChatEnableProvider>
                <Router
                  isAuthenticated={isAuthenticated}
                  onLogin={handleLogin}
                  onLogout={handleLogout}
                  userDesignation={userDesignation}
                />
              </ChatEnableProvider>
            </ThemeProvider>
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
    </DarkModeProvider>
  );
}
